import { Link } from '@tanstack/react-router';
import media from 'style-utils/media-queries';
import styled from 'styled-components';

export const MenuTabsWrapper = styled.ul`
  list-style: none;
  display: flex;
  flex: 1 1 auto;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  padding-left: 36px;
  color: #fff;
  height: 100%;

  & > li {
    height: 100%;
    color: inherit;
    flex: 0 1 auto;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    overflow: hidden;
    justify-content: flex-start;
  }
`;

export const MenuTabLink = styled(Link)`
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: inherit;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 27px;
  letter-spacing: 0;
  position: relative;

  &[id^='expanded-menu-'] {
    color: var(--expanded-menu-color);
  }

  &:hover,
  &.active-tab {
    color: var(--slidein-header-tab-link-hover-desktop);
  }

  &.active-tab:after,
  &:hover:after {
    content: '';
    bottom: 0;
    left: 0;
    position: absolute;
    width: calc(100% - 27px);
    height: 2px;
    background: var(--border-color-tab-link-hover);
  }

  li:last-child > & {
    padding-right: 0;
  }

  li:last-child > &.active-tab:after,
  li:last-child > &:hover:after {
    width: 100%;
  }

  ${media.desktop`
    padding-right: 32px;

    li:last-child > & {
      padding-right: 32px;
    }

    li:last-child > &.active-tab:after,
    li:last-child > &:hover:after {
      width: calc(100% - 32px);
    }

    &.active-tab:after,
    &:hover:after {
      width: calc(100% - 32px);
    }
  `}
`;
